import { render } from "./MyFooter.vue?vue&type=template&id=731e12c7"
import script from "./MyFooter.vue?vue&type=script&lang=js"
export * from "./MyFooter.vue?vue&type=script&lang=js"

import "./MyFooter.vue?vue&type=style&index=0&id=731e12c7&lang=css"

import exportComponent from "/home/merlyn/Working/xiaorui.li/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__